import { RingFinishEnum } from '@jouzen/ecom-components/v3/enums/ringFinish';
import { type FocusEvent, useRef, useState } from 'react';
import { useFocusWithin } from 'react-aria';

import SizeSelectionEnum from '@/app/enums/SizeSelectionEnum';
import WarrantySelectionEnum from '@/app/enums/WarrantySelectionEnum';

import type { UseRingScroller } from './types';
import { useScroller } from './useScroller';

const currentStep = {
  [RingFinishEnum.Silver]: 0,
  [RingFinishEnum.Black]: 0,
  [RingFinishEnum.Stealth]: 0,
  [RingFinishEnum.BrushedSilver]: 0,
  [RingFinishEnum.Gold]: 0,
  [RingFinishEnum.RoseGold]: 0,
  [RingFinishEnum.Midnight]: 0,
  [RingFinishEnum.Cloud]: 0,
  [RingFinishEnum.Tide]: 0,
  [RingFinishEnum.Petal]: 0,
  [SizeSelectionEnum.SizingKit]: 1,
  [SizeSelectionEnum.ChooseSize]: 1,
  [WarrantySelectionEnum.OneYear]: 2,
  [WarrantySelectionEnum.TwoYear]: 2,
  [WarrantySelectionEnum.ThreeYear]: 2,
};

const useRingScroller = (): UseRingScroller => {
  const [currentStepId, setCurrentStepId] = useState<number>(0);
  const prevStepId = useRef<number>(0);

  const onFocusWithin = (e: FocusEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const target = e.target as HTMLInputElement;
    if (target.value in currentStep) {
      setCurrentStepId(currentStep[target.value as keyof typeof currentStep]);
    }
  };

  const { focusWithinProps } = useFocusWithin({
    onFocusWithin,
  });

  const { sectionRefs } = useScroller(currentStepId, prevStepId);

  return { focusWithinProps, sectionRefs };
};

export default useRingScroller;
